"use strict";

var _Object$defineProperty = require("@babel/runtime-corejs3/core-js/object/define-property");
var _interopRequireDefault = require("@babel/runtime-corejs3/helpers/interopRequireDefault");
_Object$defineProperty(exports, "__esModule", {
  value: true
});
exports.getI18nInitOptions = void 0;
var _startsWith = _interopRequireDefault(require("@babel/runtime-corejs3/core-js/instance/starts-with"));
var _merge2 = _interopRequireDefault(require("lodash/merge"));
var _getSelectedLanguageCode = require("./get-selected-language-code");
var _i18nextLocalstorageBackend = _interopRequireDefault(require("i18next-localstorage-backend"));
var _i18nextResourcesToBackend = _interopRequireDefault(require("i18next-resources-to-backend"));
var _flattenResource = require("./flatten-resource");
var _handleError = require("../../handle-error");
const localStorageBackendDefaultOptions = {
  prefix: 'bhr_i18n_',
  // avoid local cache in development
  store: typeof window !== 'undefined' && window.ENV === 'prod' ? localStorage : null
};

/**
 * Enables using structured resources, e.g. { 'hello': { translation: 'Hello' } }
 */
function makeGetResources(getResources) {
  return (0, _i18nextResourcesToBackend.default)(async (language, namespace) => {
    try {
      const resource = await getResources(language, namespace);
      if (!(0, _startsWith.default)(language).call(language, 'en')) {
        return resource;
      }
      // TODO: do this at build time for prod
      return (0, _flattenResource.flattenResource)(resource);
    } catch (error) {
      (0, _handleError.handleError)(error);
      throw error;
    }
  });
}
const getI18nInitOptions = (options = {}) => {
  const {
    backendLocalStorageOptions,
    getResources,
    ...rest
  } = options;
  const backendOverrides = {
    backend: {
      backendOptions: [backendLocalStorageOptions]
    }
  };
  return (0, _merge2.default)({
    // how we load translations (JSON files)
    backend: {
      // backends are checked in order
      backends: [_i18nextLocalstorageBackend.default, ...(getResources ? [makeGetResources(getResources)] : [])],
      // order corresponds to `backends`
      backendOptions: [localStorageBackendDefaultOptions]
    },
    // if a translation is missing, use the template, which should always have the English translation, which is better than showing the key
    fallbackLng: 'en',
    // default language
    lng: (0, _getSelectedLanguageCode.getSelectedLanguageCode)(),
    // prevent loading additional translations
    load: 'currentOnly',
    // support legacy sprintf placeholders
    postProcess: ['preSprintf', 'sprintf'],
    // enable structured resources, e.g. { 'hello': { translation: 'Hello' } }
    returnObjects: true
  }, backendOverrides, rest);
};
exports.getI18nInitOptions = getI18nInitOptions;